var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsGarage = function SvgLeonInmobiliariaIconsGarage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "leon-inmobiliaria-icons-garage_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-garage_svg__st0{display:none}.leon-inmobiliaria-icons-garage_svg__st1{fill:currentcolor}.leon-inmobiliaria-icons-garage_svg__st1,.leon-inmobiliaria-icons-garage_svg__st2{display:inline}.leon-inmobiliaria-icons-garage_svg__st3{fill:currentcolor}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "leon-inmobiliaria-icons-garage_svg__st3",
    d: "M10.4 16.8v66.3H89.6V16.8H10.4zm15.9 63.1v-7.7h47.4v7.7H26.3zm47.4-33.5H26.3v-7.8h47.4v7.8zm0 3.2v8H26.3v-8h47.4zm0 11.3v8H26.3v-8h47.4zm12.6 19H77V35.3H23V79.7h-9.4V20.1h72.7v59.8z"
  })));
};
export default SvgLeonInmobiliariaIconsGarage;